export default function() {
  const widgetName = 'mainFeature';
  const widgetOpts = mainFeatureOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: true,
      text: 'BUY NOW',
    },

    cardWidgetLoaded: function(data, owl, hasData) {
      $('#mainFeature .buttonwrap a').addClass('button');
      $('#mainFeature .buttonwrap a').removeAttr('target');

      $('#mainFeature .buttonwrap a').each(function () {
        let link = $(this);
        if (!link.text().trim()) {
          link.remove();
        }
      });

      $('#mainFeature .card-widget-item').each(function () {
        var title = $(this).find('.card-widget-title');
        var titleText = title.text();
        var characterLimit = 40;

        if (titleText.length > characterLimit) {
          var trimmedText = titleText.substring(0, characterLimit);
          title.text(trimmedText);
        }

        if (data.items.length === 1) {
          $("#mainFeature").addClass('singleSlide')
        }

        $("#mainFeature a.card-widget-item").each(function () {
          var $this = $(this);
          $this.removeClass('void-link');
          var div = $("<div>", {
            class: $this.attr("class"),
            html: $this.html(),
          });
          $this.replaceWith(div);
        });

        $(".image-container").each(function () {
          var $this = $(this);
          var title = $this.closest('.card-widget-item').find('.card-widget-title').text();
          $this.attr("aria-label", title);
        });
      });
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: ['all'],
    maxItemsVisible: 0,
    moreButton: {
      visible: true,
      text: 'MORE'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    slideshow: true,
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 0,
      navText: ['<', '>'],
      nav: true,
      dots: true,
      autoplay: true
    },
    textOverImage: false
  });
}